<template>
    <div>
        <h1 class="h3 mb-3 text-gray-800">
            {{ $t("Cadastrar Histórico de Acolhimento") }}
        </h1>

        <form @submit.prevent="submit" ref="addItem">
            <div class="row">
                <form-select
                    v-model="item.pessoas"
                    :multiple="true"
                    label="Usuário(s)"
                    :itens="pessoas"
                    :required="true"
                    grid="12"
                />

                <form-select
                    v-if="!loadOutra"
                    v-model="item.unidade_acolhedora_id"
                    label="Selecione a Unidade Acolhedora"
                    grid="12"
                    :itens="unidades"
                    :required="true"
                    ajuda="Se a Unidade Acolhedora não for encontrada na lista você pode marcar a opção abaixo (Outra Unidade?) e digitar o nome da Unidade Acolhedora"
                />

                <form-toggle
                    grid="12"
                    mt="0"
                    v-model="loadOutra"
                    label="Outra Unidade?"
                />

                <form-input
                    v-model="item.outra_unidade"
                    label="Digite o nome da Unidade Acolhedora"
                    grid="12"
                    v-if="loadOutra"
                    :required="true"
                />

                <form-calendar
                    v-model="item.data_inicial"
                    grid="6"
                    label="Data de início"
                    :required="true"
                />
                <form-calendar
                    v-model="item.data_final"
                    grid="6"
                    label="Data Final"
                />

                <form-textarea-editor
                    v-model="item.detalhes"
                    grid="12"
                    label="Detalhes do Acolhimento"
                    :required="true"
                />

                <form-file
                    @submit="submitFile"
                    multiple
                    btn-text="Iniciar"
                    :progress="progressCompleted"
                />
            </div>
            <div class="row pt-4 px-0 d-flex justify-content-end">
                <div class="col-auto px-2 text-right">
                    <a class="btn btn-default" @click="$emit('voltar')">
                        <i class="mdi mdi-arrow-left" />
                    </a>
                    <button
                        class="btn btn-success btn-submit"
                        data-style="zoom-in"
                        type="submit"
                    >
                        <i class="mdi mdi-content-save" />
                        {{ $t("Salvar") }}
                    </button>
                </div>
            </div>
        </form>
    </div>
</template>
<script>
export default {
    props: ["familia"],
    name: "Add",
    data() {
        return {
            item: {
                pessoas: null,
                publico_alvo: [],
            },
            tecnicos: [],
            unidades: [],
            files: [],
            loadOutra: false,
            progressCompleted: 0,
            campoExtra: false,
        };
    },
    computed: {
        pessoas() {
            let pessoas = this.familia.familiares ?? [];
            pessoas = pessoas.filter((elem) => {
                return elem.estado_cadastral_cadunico <= 4;
            });
            const map = pessoas.map((elem) => ({
                id: elem.id,
                value:
                    elem.posicao_familiar == 1
                        ? "<b>RF - </b> " +
                          elem.nome_completo +
                          " <b>" +
                          elem.idade +
                          " ano(s)</b>"
                        : elem.nome_completo +
                          " <b>" +
                          elem.idade +
                          " ano(s)</b>",
            }));
            return map;
        },
    },
    mounted() {
        this.getUnidades();
    },
    methods: {
        submitFile(files) {
            this.files = files;
        },
        getTecnicos(unidade_id) {
            this.loadUser = true;
            axios
                .get(`api/dashboard/tecnicos/get/externos/${unidade_id}`)
                .then((response) => {
                    this.tecnicos = response.data;
                })
                .finally(() => {
                    this.loadUser = false;
                });
        },
        getUnidades() {
            axios
                .get(`api/dashboard/unidades/get/externas`)
                .then((response) => {
                    this.unidades = response.data;
                });
        },
        submit() {
            this.item.familia_id = this.$route.query.familia_id;

            // if (this.item.data_inicial) {
            //     this.item.data_inicial = moment(
            //         this.item.data_inicial,
            //         "YYYY-MM-DD"
            //     ).format("YYYY-MM-DD");
            // }

            // if (this.item.data_final) {
            //     this.item.data_final = moment(
            //         this.item.data_final,
            //         "YYYY-MM-DD"
            //     ).format("YYYY-MM-DD");
            // }

            let formData = new FormData();

            if (this.files.length > 0 && this.files.length != undefined) {
                for (const i of Object.keys(this.files)) {
                    formData.append("anexos[]", this.files[i]);
                }
            } else {
                formData.append("anexos", this.files);
            }

            for (var key in this.item) {
                if (key != "pessoas") {
                    formData.append(key, this.item[key]);
                }
            }

            for (const i of Object.keys(this.item.pessoas)) {
                formData.append("pessoas[]", this.item.pessoas[i]);
            }

            let ladda = Ladda.create(document.querySelector(".btn-submit"));
            ladda.start();

            axios
                .post(`api/dashboard/familia/acolhimentos`, formData, {
                    header: { "Content-Type": "multipart/form-data" },
                    onUploadProgress: (event) => {
                        let progress = Math.round(
                            (event.loaded * 100) / event.total
                        );
                        this.progressCompleted = progress;
                    },
                })
                .then((response) => {
                    ladda.stop();
                    this.$snack.success({
                        button: false,
                        text: response.data.data.message,
                    });
                    this.$emit("voltar");
                    this.$emit("reload");
                })
                .finally(() => {
                    this.progressCompleted = 0;
                    this.files = [];
                });
        },
    },
};
</script>
